import { Image, ImageSourcePropType, StyleSheet, View } from "react-native"
import ProgressIndicator from "../../../components/quality-check/progress-indicator"
import { useState } from "react"
import Wrapper from "../../../components/wrapper"
import { Header } from "../../../components/header"
import CustomButton from "../../../components/button"
import { TranslateText } from "../../../components/translate-text"

type QualityCheckStep = {
    description: string,
    image: ImageSourcePropType,
}

type QualityCheckProps = {
    setIndex: (index: number) => void,
}

const quality_check_steps: QualityCheckStep[] = [
    {
        description: "Lean your phone against a surface or use a phone stand",
        image: require("../../../images/quality-check/qc-1.png"),
    },
    {
        description: "Make sure that you are in frame with a good amount of light!",
        image: require("../../../images/quality-check/qc-2.png"),
    },
    {
        description: "Take time to read the question and click \"Begin\" to start the recording!",
        image: require("../../../images/quality-check/qc-3.png"),
    },
    {   
        description: "Take your time to answer the question naturally!",
        image: require("../../../images/quality-check/qc-4.png"),
    }
]

const QualityCheck = ({setIndex}: QualityCheckProps) => {

    const [step, setStep] = useState(0);
    const goBack = () => {
        if(step !== 0) {
            setStep(step-1);
        } else {
            setIndex(4);
        }
    }
    const nextStep = () => {
        if (step === quality_check_steps.length-1) {
            setIndex(6);
        } else {
            setStep(step+1);
        }
    }
    
    return (
        <Wrapper backgroundColor={"#FFF"}>
            <Header heading="Quality Check" goBack={goBack}/>
            <View style={styles.contentContainer}>
                <TranslateText style={styles.greenHeading}>Quality Check</TranslateText>
                <View style={{width: '100%', height: '50%', alignItems: 'center'}}>
                    <View style={styles.yellowCircle}/>
                    <Image style={styles.placeholderImage} source={quality_check_steps[step].image}/>
                </View>
                <ProgressIndicator total_steps={quality_check_steps.length} step={step}/>
                <TranslateText style={styles.descriptionText}>{ quality_check_steps[step].description }</TranslateText>
                <CustomButton title="Next" onPress={nextStep} />
            </View>
        </Wrapper>
    )
}

const styles = StyleSheet.create({
    contentContainer: {
        height:'100%',
        width:'100%', 
        paddingTop: 120,
        paddingHorizontal: 40,
        paddingBottom: 20,
        alignItems: 'center',
    },
    greenHeading: {
        textTransform: "uppercase",
        fontWeight: "700",
        fontSize: 16,
        lineHeight: 19,
        color: "#006C48",
        marginVertical: 12,
        width: "100%",
    },
    placeholderImage: {
        width: "60%",
        height: "100%",
        resizeMode: "contain",
        marginVertical: 12,
    },
    descriptionText: {
        fontSize: 16,
    },
    yellowCircle: {
        width: 260,
        height: 260,
        borderRadius: 300,
        backgroundColor: "#fff099",
        position: "absolute",
        top: '10%'
    }
})

export default QualityCheck;